import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PrivacyComp from "@/components/PrivacyComp.vue";
import ImpressumComp from "@/components/ImpressumComp.vue";
import PubsComp from "@/components/PubsComp.vue";
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/privacy',
      name: 'privacy',
      component: PrivacyComp

    },
    {
      path: '/impressum',
      name: 'impressum',
      component: ImpressumComp

    },
    {
      path: '/pubs',
      name: 'pubs',
      component: PubsComp

    },
    {
      path: '*',
      name: 'home',
      component: Home
    }
  ]
})
